import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from '../../../utils/useRouter';
import { useSelector } from 'react-redux';
import { selectPinnedCount } from '../../../reducers/pinned.selectors';
import getCollectionTabs from './getCollectionTabs';

interface CollectionsTabsProps {
  activeTab: string;
}

const CollectionsTabs: React.FC<CollectionsTabsProps> = (props) => {
  const { activeTab } = props;
  const { t } = useTranslation();
  const { router } = useRouter();
  const tabs = getCollectionTabs(t);
  const pinnedCount = useSelector(selectPinnedCount);
  const pinnedTitle = pinnedCount ? `${tabs.pinned.label} • ${pinnedCount}` : tabs.pinned.label;

  return <Tabs
    value={activeTab}
    onChange={(_, newTab) => router.push({
      pathname: `/${newTab}`,
    })}
    variant='scrollable'
    scrollButtons='auto'
  >
    <Tab value={tabs.pinned.id} label={pinnedTitle} />
    <Tab value={tabs.ownCollections.id} label={tabs.ownCollections.label} />
    <Tab value={tabs.followedCollections.id} label={tabs.followedCollections.label} />
  </Tabs>;
};

export default CollectionsTabs;
